import { Overline } from "@/components/site/Primitives";
import { NewsletterSection } from "@/components/site/Newsletter";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["Are these physical books?", "No, my dear — each edition is a beautifully made digital book (a PDF), delivered to you the moment you purchase. You may read it on any screen, or print the pages to keep in your own kitchen."],
  ["How do I receive my purchase?", "The very moment your payment is complete, you'll be taken to a page where you can download your edition. A copy is also sent to your email, so it is always within reach."],
  ["What if I have trouble downloading?", "Write to me through the Contact page with your order details, and I shall see it put right. Every letter is read and answered."],
  ["Can I print the books?", "Of course. Each edition is typeset with your own kitchen shelf in mind — print the whole book or just the recipe cards and reference pages you wish to keep close."],
  ["Do you offer refunds?", "Because these are digital keepsakes delivered instantly, they cannot be returned. But if something is not right, do write to me — I want you to be truly happy. See our Refund Policy for more."],
  ["Will there be more editions?", "There will indeed. New books, journals and seasonal collections are gathered throughout the year. Join the Cottage Newsletter and you'll be the first to know."],
  ["Is my payment secure?", "Entirely. All payments are handled by Stripe, a trusted and secure provider. Your details never pass through my hands."],
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <section className="max-w-3xl mx-auto px-6 pt-24 pb-12 text-center">
        <Overline>A few gentle answers</Overline>
        <h1 className="text-5xl sm:text-6xl font-light mt-5 leading-none">Questions & Answers</h1>
      </section>
      <section className="max-w-3xl mx-auto px-6 pb-24">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-linen" data-testid={`faq-${i}`}>
              <AccordionTrigger className="font-serif text-2xl text-left text-brand-charcoal hover:no-underline py-6">{q}</AccordionTrigger>
              <AccordionContent className="font-body text-brand-body text-lg leading-relaxed pb-6">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <NewsletterSection />
    </div>
  );
}
